document.querySelectorAll('.offcanvas a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        var offcanvas = anchor.closest('.offcanvas');
        var bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvas);
        if (bsOffcanvas) {
            bsOffcanvas.hide();
        }
        var targetId = anchor.getAttribute('href');
        var target = document.querySelector(targetId);
        if (target) {
            setTimeout(function() {
                target.scrollIntoView({ behavior: 'smooth' });
            }, 300); // Wait for offcanvas to close
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {

    const servicosSwiper = new Swiper('.carrossel-servicos', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: '.btn-next',
            prevEl: '.btn-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            991: {
                slidesPerView: 3
            },
            1200: {
                slidesPerView: 4
            }
        }
    });

    const depoimentosSwiper = new Swiper('.carrossel-depoimentos', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.btn-next',
            prevEl: '.btn-prev',
        },
        breakpoints: {
            991: {
                slidesPerView: 2
            }
        }
    });

    const depoimentosEl = document.querySelector('.carrossel-depoimentos');
    if (depoimentosEl) {
        depoimentosEl.addEventListener('mouseenter', function () {
            depoimentosSwiper.autoplay.stop();
        });
        depoimentosEl.addEventListener('mouseleave', function () {
            depoimentosSwiper.autoplay.start();
        });
    }

    const confiamSwiper = new Swiper('.carrossel-confiam', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        }
    });
    
});

